<template>
  <transition name="fade">
    <main role="main">
      <meta-title :title="metaTitle"></meta-title>
      <section class="section section-default section-shop">
        <div
          v-if="!shopPaidSuccess"
          class="container m-container-only-s cart-container"
        >
          <div class="product-cart">
            <div class="header" v-if="card.length">
              <h1>{{ $t("shop.card") }}</h1>
              <a
                href="#"
                v-if="!skyShop.find((item) => item.state === 'processing')"
                @click.prevent="setEntity(['card', []])"
                ><svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="trash"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  class="svg-inline--fa fa-trash fa-w-14 fa-2x"
                >
                  <path
                    fill="currentColor"
                    d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
                    class=""
                  ></path>
                </svg>
                <span>{{ $t("shop.clear_card") }}</span></a
              >
            </div>
            <div class="header" v-else>
              <h1>{{ $t("shop.card_empty") }}</h1>
              <router-link to="/shop" class="button">{{
                $t("shop.start_fill_card")
              }}</router-link>
            </div>

            <div
              class="cart-row"
              v-for="item in computedCard"
              :key="item.productId"
            >
              <div>
                <img :src="item.image_src" alt="" />
              </div>
              <div>{{ item.title }}</div>
              <div class="align-right">
                <template
                  v-if="item.price.position && item.price.position === 'start'"
                  >{{ item.price.currency }}</template
                >
                {{ item.price.amount }}
                <template
                  v-if="item.price.position && item.price.position === 'end'"
                  >{{ item.price.currency }}</template
                >
                <template v-else>₽</template>
              </div>
              <div class="total-price">
                <span>{{ $t("shop.count_product") }}</span>
                <p class="amount">
                  <span
                    class="minus"
                    v-if="!skyShop.find((item) => item.state === 'processing')"
                    @click.prevent="
                      changeAmount({
                        productId: item.product_id,
                        action: 'DECREMENT_AMOUNT_CARD',
                      })
                    "
                    ><svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12" cy="12" r="12" fill="#f37920" />
                      <path
                        d="M7.035 13.36H16.971V11.68H7.035V13.36Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  <b>{{ item.amount }}</b>
                  <span
                    class="plus"
                    v-if="!skyShop.find((item) => item.state === 'processing')"
                    :class="{
                      disabled: parseInt(item.volume) <= parseInt(item.amount),
                    }"
                    @click.prevent="
                      changeAmount({
                        productId: item.product_id,
                        action: 'INCREMENT_AMOUNT_CARD',
                      })
                    "
                    ><svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12" cy="12" r="12" fill="#f37920" />
                      <path
                        d="M6.55444 12.2H11.0664V16.832H12.8664V12.2H17.4504V10.52H12.8664V5.936H11.0664V10.52H6.55444V12.2Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </p>
                <strong
                  ><template
                    v-if="
                      item.price.position && item.price.position === 'start'
                    "
                    >{{ item.price.currency }}</template
                  >
                  {{ item.priceCalc }}
                  <template
                    v-if="item.price.position && item.price.position === 'end'"
                    >{{ item.price.currency }}</template
                  >
                  <template v-else>₽</template></strong
                >
              </div>
            </div>
            <div class="footer" v-if="card.length">
              <div class="cart-result">
                <span>{{ $t("orders.total_price") }}</span>
                <strong
                  ><template v-if="totalPrice.position === 'start'">{{
                    totalPrice.currency
                  }}</template>
                  {{ totalPrice.price }}
                  <template v-if="totalPrice.position === 'end'">{{
                    totalPrice.currency
                  }}</template>
                  <template v-else>₽</template></strong
                >
              </div>
              <br />
              <a
                href="#"
                @click.prevent="createOrder"
                v-if="!skyShop.find((item) => item.state === 'processing')"
                class="button"
                >{{ $t("shop.create_order") }}</a
              >
            </div>
          </div>
          <div
            class="product-payment"
            v-if="
              card.length && skyShop.find((item) => item.state === 'processing')
            "
          >
            <form>
              <div class="cols">
                <div class="col">
                  <p>
                    <strong>{{$t("planes.order_processing")}}</strong><br />
                    {{$t("planes.order_processing_details")}}
                  </p>
                </div>
                <div class="col"></div>
                <div class="col">
                  <div class="radio">
                    <div class="input">
                      <div class="input-radio">
                        <input
                          name="payment"
                          value="1"
                          v-model="form.paymentType"
                          type="radio"
                          id="input-021"
                        />
                        <span class="checkmark"></span>
                      </div>
                    </div>
                    <div class="label">
                      <label for="input-021">{{
                        $t("planes.payment_cashe")
                      }}</label>
                    </div>
                  </div>
                  <div class="radio">
                    <div class="input">
                      <div class="input-radio">
                        <input
                          name="payment"
                          value="1"
                          v-model="form.paymentType"
                          type="radio"
                          id="input-02"
                        />
                        <span class="checkmark"></span>
                      </div>
                    </div>
                    <div class="label">
                      <label for="input-02">{{
                        $t("planes.payment_by_terminal")
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="field-row">
                    <label for="email">{{ $t("planes.email") }}</label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      v-model="form.email"
                      :class="{ is_invalid: errors.email }"
                    />
                    <p class="error-description" v-if="errors.email">
                      {{ $t("planes.email_error") }}
                    </p>
                  </div>

                  <div class="field-row">
                    <label for="phone">{{ $t("planes.phone") }}</label>
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      v-model="form.phone"
                      :class="{ is_invalid: errors.phone }"
                    />
                    <p class="error-description" v-if="errors.phone">
                      {{ $t("planes.phone_error") }}
                    </p>
                  </div>

                  <div class="field-row">
                    <label for="code" v-html="$t('planes.code')"></label>
                    <input
                      type="text"
                      name="code"
                      id="code"
                      v-model="form.code"
                      :class="{ is_invalid: errors.code }"
                      :placeholder="$t('planes.by_reported')"
                    />
                    <p class="error-description" v-if="errors.code">
                      {{ $t("planes.code_error") }}
                    </p>
                  </div>
                </div>
                <div class="col">
                  <p class="notice">
                    {{ $t("planes.not_close_info") }}
                  </p>
                </div>
                <div class="col">
                  <div class="buttons">
                    <input
                      type="submit"
                      class="submit cancel"
                      name="cancel"
                      :value="$t('planes.cancel_page')"
                      @click.prevent="cancelOrderAction()"
                    />
                    <input
                      type="submit"
                      class="submit"
                      name="enter"
                      :class="{ active: codeValidate }"
                      :value="$t('orders.button_pay')"
                      @click.prevent="checkPin()"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- :item="contentData" -->
        <success-payment-shop
          v-if="shopPaidSuccess"
        ></success-payment-shop>
      </section>
    </main>
  </transition>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import shop from "@/mixins/shop";
import SuccessPaymentShop from "@/components/popup/SuccessPaymentShop";

export default {
  name: "Shop",
  components: {
    SuccessPaymentShop,
  },
  mixins: [shop],
  title() {
    return this.$t("pages.shop");
  },
  data: () => {
    return {
      form: {
        phone: "",
        email: "",
        code: "",
        paymentType: 1,
      },
      errors: {
        phone: false,
        email: false,
        code: false,
      },
    };
  },
  computed: {
    ...mapState("order", {
      skyShop: (state) => state.skyShop,
    }),
	...mapState("shop", {
		shopPaidSuccess: (state) => {
        return state.shopPaidSuccess;
      }
	}),
    ...mapState("user", {
      user: (state) => state.user,
    }),
    emailValidate() {
      let emailValidator = new RegExp(
        "[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?"
      );
      let validEmail = emailValidator.test(this.form.email);
      if (!validEmail) {
        return false;
      }

      return true;
    },
    phoneValidate() {
      let validator = new RegExp("^[0-9]+$");
      let test = validator.test(this.form.phone);
      if (!test || this.form.phone.length < 10) {
        return false;
      }

      return true;
    },
    codeValidate() {
      return this.form.code.length >= 3;
    },
    computedCard() {
      let result = [];
      if (this.card.length === 0) {
        return result;
      }
      for (let i = 0; i < this.card.length; i++) {
        for (let iC = 0; iC < this.catalog.length; iC++) {
          let item = this.catalog[iC].goods.find(
            (it) => it.product_id === this.card[i].productId
          );
          if (item) {
            result.push({
              ...item,
              amount: this.card[i].amount,
              priceCalc: this.card[i].amount * item.price.amount,
            });
          }
        }
      }
      return result;
    },
    totalPrice() {
      let position = this.computedCard[0].price.position || "end";
      let currency =
        this.computedCard[0].price.currency === "rub"
          ? "₽"
          : this.computedCard[0].price.currency;

      const totalPrice = {
        price: this.computedCard.reduce((a, b) => a + b.priceCalc, 0),
        position,
        currency,
      };

      this.setEntity(["shopPaidInfo", totalPrice]);

      return totalPrice;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.actionIndex();
    });
  },
  methods: {
    ...mapActions("order", {
      cancelOrder: "cancelOrder",
      createOrderAction: "setOrderSkyShop",
      updateOrderAction: "updateOrderState",
    }),
    // ...mapState("shop", {
    //   shopPaidInfo: (state) => state.shopPaidInfo,
    // }),
    ...mapMutations("shop", {
      setEntity: "SET_ENTITY",
    }),
    ...mapMutations("order", {
      deleteOrder: "DELETE_ENTITY",
    }),
    async createOrder() {
      await this.cancelOrderAction();
      let items = [];
      for (let i = 0; i < this.computedCard.length; i++) {
        items.push({
          name: this.computedCard[i].title,
          id: parseInt(this.computedCard[i].product_id),
          isPaid: true,
          amount: this.computedCard[i].amount,
          price: parseInt(this.computedCard[i].price.amount),
        });
      }
      // guid and pin
      await this.createOrderAction({
        paymentType: 2,
        items: items,
      });
    },
    async checkPin() {
      // this.errors.email = !(this.form.email.length > 1 && this.emailValidate);
      // this.errors.phone = !(this.form.phone.length > 1 && this.phoneValidate);
      this.errors.code = !(this.form.code.length > 1 && this.codeValidate);
      if (!this.errors.code) {
        try {
          await this.axios.post("/api/board/checkPin", {
            seat: this.user.seat,
            guid: this.skyShop.find((item) => item.state === "processing").guid,
            pin: +this.form.code,
            payType: 2,
          });
          this.errors.code = false;

		  this.setEntity(["shopPaidCode", +this.form.code]);

          await this.updateOrderAction({
            guid: this.skyShop.find((item) => item.state === "processing").guid,
            state: "paid",
          });

          this.deleteOrder([
            "skyShop",
            {
              guid: this.skyShop.find((item) => item.state === "processing")
                .guid,
            },
            "guid",
          ]);
          this.setEntity(["card", []]);

          this.setEntity(["shopPaidSuccess", true]);
        } catch (e) {
          this.errors.code = true;
        }
      }
    },
    async cancelOrderAction() {
      if (this.skyShop.find((item) => item.state === "processing")) {
        await this.updateOrderAction({
          guid: this.skyShop.find((item) => item.state === "processing").guid,
          state: "canceledByPassenger",
        });
        this.deleteOrder([
          "skyShop",
          {
            guid: this.skyShop.find((item) => item.state === "processing").guid,
          },
          "guid",
        ]);
      }
    },
  },
};
</script>

<style scoped>
.disabled {
  opacity: 0.4;
}
.active {
  background-color: #f37920 !important;
}
</style>
